
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import url from "../api/url";
import { elToast } from "../functions/Alerta";
import calcularEdad from "../functions/calcularEdad";
import { useEmpleadoStore } from "../stores/useEmpleadoStore";

export const useRegistro = () => {

    const { URL } = url()

    const objLogueado = useEmpleadoStore(state => state.objLogueado)

    if (objLogueado.permitido !== "empleado") {
        window.location = "/"
    }

    // alertas
    const [cargando, setCargando] = useState(false)
    const datosInicial = {
        funcion: 'guardarDatosGenerales',
        fecha_ingreso: '',
        rfc: '',
        nss: '',
        curp: '',
        fnac: '',
        edad: '',
        nacionalidad: '',
        estado_civil: '',
        sexo: '',
        tel: '',
        cel: '',
        email_personal: '',
        correo: objLogueado.email,
        lugar_de_nacimiento: ''
    }
    const [formDatosInicial, setFormDatosInicial] = useState( datosInicial )


    // funciones
    const testear = () => {

        let formData = new FormData();
        formData.append('funcion', 'testear');

        fetch( URL , {
            method: 'POST',
            body: formData
        })
        .then(res => res.json())
        .then(function (d) {


            if (d[0] === 0) {

            } else {
                Swal.fire(
                    'Hay un problema al conectar con el servidor.',
                    '',
                    'error'
                )
            }
        })
        .catch((error) => {
            setCargando(false)
            Swal.fire(
                'Hay un problema al conectar con el servidor.',
                '',
                'error'
            )
        });
    }

    const traerDatos = () => {

        fetch( URL, {
            method: 'post',
            body: JSON.stringify({ funcion: 'traerDatos', correo: objLogueado.email })
        })
        .then( res => res.json() )
        .then( e => {
            if ( e ) {
                setFormDatosInicial({
                    ...formDatosInicial,
                    ...e
                })
            }
        })
        .catch( a => {
            elToast( 'Hay problemas al traer tu información personal', 'error' )
        })
    }


    const guardarDatosGenerales = () => {

        setCargando( true )
        fetch( URL, {
            method: 'post',
            body: JSON.stringify( formDatosInicial )
        })
        .then( res => res.json() )
        .then( function (d) {
            if ( d.codigo === 1 ) {
                elToast( d.mensaje )
            } else {
                elToast( d.mensaje, 'error' )
            }
        })
        .catch( a => {
            elToast( "Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", 'error' )
        })
        .finally( () => setCargando( false ) )
    }


    // efectos
    useEffect(() => {
        testear()

        traerDatos()
        // eslint-disable-next-line
    }, [])


    useEffect(() => {

        if (formDatosInicial.fnac?.length > 0) {
            var edadCalculada = calcularEdad(formDatosInicial.fnac)
            setFormDatosInicial({
                ...formDatosInicial,
                edad: edadCalculada
            })
        }
        // eslint-disable-next-line
    }, [formDatosInicial.fnac])

    return {
        cargandoGenerales: cargando,
        formDatosInicial,
        setFormDatosInicial,
        guardarDatosGenerales
    }

}
